import { IDialogAction } from './IDialogAction';
import { DialogSignalRService } from '../services/DialogSignalRService';
import { DialogState } from '../models/DialogState';
import { Store } from 'redux';

export const REMOVE_AUDIENCE_FILTER = 'REMOVE_AUDIENCE_FILTER';

export class RemoveAudienceFilterAction implements IDialogAction {
    public readonly type = REMOVE_AUDIENCE_FILTER;
    public constructor(public payload: any, private _service?: DialogSignalRService) {}
    public middleware(store: Store): any {
        if(this._service) {
            let state = store.getState() as DialogState;
            this._service.setFilter(
                state.feed.currentTabId,
                []
            );
        }
        return;
    }
    public reducer(state: DialogState): DialogState {
        state.feed.audienceFilters = [];
        state.feed.messagesReady = false;
        state.feed.messages = [];
        return state;
    }
}


export const RemoveAudienceFilterActionTypeMapping = {
    [REMOVE_AUDIENCE_FILTER]: RemoveAudienceFilterAction
};